import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import styles from "../../styles/tenant.module.css"
import { useQuery } from "@apollo/client";
import { GET_API_CONFIG_BY_ID, GET_TENANT_BY_ID, UPDATE_TENANTS } from "../../graphql/TenantQueries";



function ApiConfigModal({ setOpenApiModal, setOpenActionModal, fieldData }: any) {
    const { loading, error, data } = useQuery(GET_API_CONFIG_BY_ID, { variables: { id: fieldData } })
    const { loading: tenantLoading, error: tenantError, data: tenantData } = useQuery(GET_TENANT_BY_ID, { variables: { id: fieldData } })

    if (loading) return <h3>Loading...</h3>
    return (
        <>
            <div className={styles["formModalContainer"]}>
                <div className={styles["title"]}>
                    <h1>Tenant API Configuration</h1>
                    <h4 style={{ display: 'flex' }}>Tenant</h4>
                    <div style={{ display: 'grid' }}>
                        <div>
                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Tenant Name:</label>
                            <p style={{ float: 'left' }}>{tenantData?.getTenantById?.name ? tenantData.getTenantById.name : ""}</p>
                        </div>
                        <div>
                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Tenant Display Name:</label>
                            <p style={{ float: 'left' }}>{tenantData?.getTenantById?.displayName ? tenantData.getTenantById.displayName : ""}</p>
                        </div>
                        <div>
                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Tenant ID:</label>
                            <p style={{ float: 'left' }}>{tenantData?.getTenantById?.id ? tenantData.getTenantById.id : ""}</p>
                        </div>
                        <hr/>
                    </div>
                    {data?.getApiConfigByTenantId.length === 0 && <h3>No API Configuration for this Tenant</h3>}

                    {data?.getApiConfigByTenantId && data.getApiConfigByTenantId?.map((el: any) =>
                        <>
                            <h4 style={{ display: 'flex' }}>API Configuration</h4>
                            <div style={{ display: 'grid' }}>
                                <div>
                                    <label style={{ float: 'left', paddingRight: '8px' }}>API Name:</label>
                                    <p style={{ float: 'left' }}>{el.name}</p>
                                </div>
                                <div>
                                    <label style={{ float: 'left', paddingRight: '8px' }}>API Key:</label>
                                    <p style={{ float: 'left' }}>{el.key}</p>
                                </div>
                                <div>
                                    <label style={{ float: 'left', paddingRight: '8px' }}>API URL:</label>
                                    <p style={{ float: 'left' }}>{el.url}</p>
                                </div>
                                <div>
                                    <label style={{ float: 'left', paddingRight: '8px' }}>Collector Type:</label>
                                    <p style={{ float: 'left' }}>{el.collectorType}</p>
                                </div>
                                <div>
                                    <label style={{ float: 'left', paddingRight: '8px' }}>Enabled:</label>
                                    <p style={{ float: 'left' }}>{el.enabled ? el.enabled.toString() : 'false'}</p>
                                </div>
                                <div>
                                    <label style={{ float: 'left', paddingRight: '8px' }}>Timezone:</label>
                                    <p style={{ float: 'left' }}>{el.timezone}</p>
                                </div>
                                <hr/>
                            </div>

                        </>

                    )
                    }
                    <div style={{ paddingTop: '30px' }}>
                        <button
                            onClick={() => {
                                setOpenApiModal(false);
                            }}
                            className={styles["button"]}
                            style={{ display: 'block', }}
                        >
                            Cancel
                        </button>
                    </div>

                </div>
            </div>
        </>

    )
}

export default ApiConfigModal;